import React, { useCallback, useRef } from 'react';
import { AccountingWebSocketContext } from './AccountingWebSocketContext';

const AccountingWebSocketProvider = ({ children }) => {
  const handlers = useRef(new Map());

  const registerHandler = useCallback((entityType, handler) => {
    handlers.current.set(entityType, handler);
  }, []);

  const unregisterHandler = useCallback((entityType) => {
    handlers.current.delete(entityType);
  }, []);

  const dispatchMessage = useCallback((data) => {
    if (!data) return;
    const entity = data?.action_data?.entity ?? data?.action_data?.record_type;
    handlers.current.get(entity)?.(data);
  }, []);

  return (
    <AccountingWebSocketContext.Provider value={{ dispatchMessage, registerHandler, unregisterHandler }}>
      {children}
    </AccountingWebSocketContext.Provider>
  );
};

export default AccountingWebSocketProvider;
